import {parse} from 'path'
import React, {useEffect, useState} from 'react'
import {Form, Modal} from 'react-bootstrap'

const ChangeCOG = ({show, handleClose, handleUpdate, user}: any) => {
  const [cog, setCog] = useState<{
    mms: string
    sms: string
    commissionInboundRates: any[]
    commissionOutboundRates: any[]
  }>({
    mms: '',
    sms: '',
    commissionInboundRates: [],
    commissionOutboundRates: [],
  })

  useEffect(() => {
    setCog({
      mms: user?.cog?.mms,
      sms: user?.cog?.sms,
      commissionInboundRates: user?.commissionInboundRates || [],
      commissionOutboundRates: user?.commissionOutboundRates || [],
    })
  }, [user])

  const handleSubmit = () => {
    const cleanCog = {
      ...cog,
      commissionInboundRates: cog.commissionInboundRates.map((it) => ({
        ...it,
        rate: parseFloat(it.rate) || 0,
      })),
      commissionOutboundRates: cog.commissionOutboundRates.map((it) => ({
        ...it,
        rate: parseFloat(it.rate) || 0,
      })),
    }

    handleUpdate(cleanCog)
    handleClose()
  }

  const addCommissionRates = (type: string) => {
    const newRate = {
      duration: 0,
      unit: 'year',
      rate: 0,
    }

    if (type === 'inbound') {
      setCog({
        ...cog,
        commissionInboundRates: [...cog.commissionInboundRates, newRate],
      })
    }

    if (type === 'outbound') {
      setCog({
        ...cog,
        commissionOutboundRates: [...cog.commissionOutboundRates, newRate],
      })
    }
  }

  const removeCommissionRates = (i: number, type: string) => {
    if (type === 'inbound') {
      let tmpCommissionInboundRates = [...cog.commissionInboundRates]
      tmpCommissionInboundRates.splice(i, 1)

      setCog({
        ...cog,
        commissionInboundRates: tmpCommissionInboundRates,
      })
    }

    if (type === 'outbound') {
      let tmpCommissionOutboundRates = [...cog.commissionOutboundRates]
      tmpCommissionOutboundRates.splice(i, 1)

      setCog({
        ...cog,
        commissionOutboundRates: tmpCommissionOutboundRates,
      })
    }
  }

  const handleChange = (i: number, e: string, field: string, type: string) => {
    if (type === 'inbound' && cog.commissionInboundRates.length > i) {
      let tmpRate: any = {...cog.commissionInboundRates[i]}
      tmpRate[field] = e || 0
      const tmpCommissionInboundRates = [...cog.commissionInboundRates]
      tmpCommissionInboundRates[i] = tmpRate

      setCog({
        ...cog,
        commissionInboundRates: tmpCommissionInboundRates,
      })
    }

    if (type === 'outbound' && cog.commissionOutboundRates.length > i) {
      let tmpRate: any = {...cog.commissionOutboundRates[i]}
      tmpRate[field] = e || 0

      const tmpCommissionOutboundRates = [...cog.commissionOutboundRates]
      tmpCommissionOutboundRates[i] = tmpRate

      setCog({
        ...cog,
        commissionOutboundRates: tmpCommissionOutboundRates,
      })
    }
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-600px'
        className='vh-100 '
        size='sm'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h2> COG </h2>
        </div>
        <div className='modal-body p-12'>
          <Form.Group controlId='sms-cog' className='pb-5'>
            <Form.Label>SMS COG</Form.Label>
            <div className='password-wrap'>
              <Form.Control
                type='text'
                as={'input'}
                placeholder='SMS COG'
                name='sms-cog'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                value={cog.sms}
                onChange={(e) => setCog({...cog, sms: e.target.value})}
              />
            </div>
          </Form.Group>
          <Form.Group controlId='mms-cog' className='pb-5'>
            <Form.Label>MMS COG</Form.Label>
            <Form.Control
              type='text'
              as={'input'}
              placeholder='MMS COG'
              name='mms-cog'
              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
              value={cog.mms}
              onChange={(e) => setCog({...cog, mms: e.target.value})}
            />
          </Form.Group>

          {/* <Form.Group controlId='sms-cog' className='pb-5'>
            <Form.Label>Commision</Form.Label>
            <div className='password-wrap'>
              <Form.Control
                type='text'
                placeholder='Commission Percentage'
                name='sms-cog'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                value={cog.commissionPercentage}
                onChange={(e) => setCog({...cog, commissionPercentage: e.target.value})}
              />
            </div>
          </Form.Group> */}

          <Form.Group controlId='inbound-commission' className='pb-5'>
            <Form.Label>Inbound Commission</Form.Label>
            <div className='md-12'>
              {cog.commissionInboundRates?.map((key: any, index: any) => (
                <div className='row' key={index}>
                  <div className='col-md-5 mb-3 col-lg-5'>
                    <input
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 me-3'
                      type='text'
                      value={key.duration > 0 ? key.duration : ''}
                      onChange={(e) =>
                        handleChange(index, e.currentTarget.value, 'duration', 'inbound')
                      }
                      placeholder='Year'
                    />
                  </div>

                  <div className='col-md-5 mb-3 col-lg-5'>
                    <input
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 me-3'
                      type='text'
                      value={key.rate > 0 ? key.rate : ''}
                      onChange={(e) =>
                        handleChange(index, e.currentTarget.value, 'rate', 'inbound')
                      }
                      placeholder='Rate'
                    />
                  </div>

                  <div className='col-md-2 mb-3 col-lg-2'>
                    <button
                      className='btn btn-danger'
                      onClick={() => removeCommissionRates(index, 'inbound')}
                    >
                      <i className='bi bi-x fs-3'></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className='row'>
              <div className='col-md-6 col-lg-10'>
                <button
                  className='btn gray_bg_purple w-100'
                  disabled={cog.commissionInboundRates?.length === 5}
                  onClick={() => addCommissionRates('inbound')}
                >
                  <i className='bi bi-plus'></i> Add Inbound Rate
                </button>
              </div>
            </div>
          </Form.Group>

          <Form.Group controlId='outbound-commission' className='pb-5'>
            <Form.Label>Outbound Commission</Form.Label>
            <div className='md-12'>
              {cog.commissionOutboundRates?.map((key: any, index: any) => (
                <div className='row' key={index}>
                  <div className='col-md-5 mb-3 col-lg-5'>
                    <input
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 me-3'
                      type='text'
                      value={key.duration > 0 ? key.duration : ''}
                      onChange={(e) =>
                        handleChange(index, e.currentTarget.value, 'duration', 'outbound')
                      }
                      placeholder='Year'
                    />
                  </div>

                  <div className='col-md-5 mb-3 col-lg-5'>
                    <input
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 me-3'
                      type='text'
                      value={key.rate > 0 ? key.rate : ''}
                      onChange={(e) =>
                        handleChange(index, e.currentTarget.value, 'rate', 'outbound')
                      }
                      placeholder='Rate'
                    />
                  </div>

                  <div className='col-md-2 mb-3 col-lg-2'>
                    <button
                      className='btn btn-danger'
                      onClick={() => removeCommissionRates(index, 'outbound')}
                    >
                      <i className='bi bi-x fs-3'></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className='row'>
              <div className='col-md-6 col-lg-10'>
                <button
                  className='btn gray_bg_purple w-100'
                  disabled={cog.commissionOutboundRates?.length === 5}
                  onClick={() => addCommissionRates('outbound')}
                >
                  <i className='bi bi-plus'></i> Add Outbound Rate
                </button>
              </div>
            </div>
          </Form.Group>

          <div className='d-flex flex-center mt-5'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={handleClose}
                className='btn btn-sm btn-light text-hover-white bg-white btn-active-primary text-primary me-2 w-100px p-3 fw-500 me-2'
              >
                Cancel
              </button>
            </div>

            <button
              type='submit'
              className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border border-primary'
              onClick={handleSubmit}
            >
              <span className='indicator-label'>Submit</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ChangeCOG
